module.exports = __webpack_public_path__ + "static/media/currency_icon.1737294c.svg";